import PropTypes from "prop-types";
import React, { memo, useEffect, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { GoArrowDown, GoArrowUp } from "react-icons/go";

const DynamicTable = ({
  cols,
  response,
  isPaginate,
  headerClass,
  rowHover,
  numberOfData,
  isBgTransparent,
  PaginationOnButtonClick,
  fixedHeight,
  hideHeader,
  isloading,
  currentPage = 1,
}) => {
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [toggleTable, setToggleTable] = useState(false);
  const [toggleArrowIcon, setToggleArrowIcon] = useState({});

  useEffect(() => {
    setData(response);
  }, [response, toggleTable]);

  const sortingFunction = (fieldName, isFieldSortable) => {
    if (!isFieldSortable) return;

    const sortedData = [...response]; // Clone the response to avoid mutating props
    if (order === "asc") {
      sortedData.sort((a, b) =>
        typeof a[fieldName] === "number" || typeof b[fieldName] === "number"
          ? a[fieldName] > b[fieldName]
            ? 1
            : -1
          : a[fieldName]?.toLowerCase() > b[fieldName]?.toLowerCase()
          ? 1
          : -1
      );
      setOrder("desc");
      setToggleArrowIcon({ [fieldName]: { up: false, down: true } });
    } else {
      sortedData.sort((a, b) =>
        typeof a[fieldName] === "number" || typeof b[fieldName] === "number"
          ? a[fieldName] < b[fieldName]
            ? 1
            : -1
          : a[fieldName]?.toLowerCase() < b[fieldName]?.toLowerCase()
          ? 1
          : -1
      );
      setOrder("asc");
      setToggleArrowIcon({ [fieldName]: { up: true, down: false } });
    }

    setData(sortedData);
    setToggleTable(!toggleTable);
  };
  const paginatedData =
    isPaginate && numberOfData
      ? data.slice((currentPage - 1) * numberOfData, currentPage * numberOfData)
      : data;

  return (
    <div
      className={`w-100 ${
        isBgTransparent ? "bg-transparent" : "bg-white shadow-sm "
      }`}
    >
      <div
        className="table-responsive "
        style={{ overflowY: "auto", height: fixedHeight ? "400px" : "" }}
      >
        <Table hover size="sm" className="mb-0 ">
          {!hideHeader && (
            <thead
              className={headerClass || ""}
              style={{
                backgroundColor: "#F1F4F9",
                border: "1px solid #F1F4F9",
              }}
            >
              <tr>
                {cols.map((head, index) => (
                  <th
                    key={head?.id || index}
                    onClick={() =>
                      head?.isSortable &&
                      sortingFunction(head?.key, head?.isSortable)
                    }
                    style={head?.headStyle}
                    className={`${head?.headClass ? head?.headClass : ""} ${
                      head?.isSortable ? "cursor-pointer" : ""
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      {head?.title}
                      {toggleArrowIcon[head?.key]?.up && head?.isSortable && (
                        <GoArrowUp className="ms-2 text-primary" />
                      )}
                      {toggleArrowIcon[head?.key]?.down && head?.isSortable && (
                        <GoArrowDown className="ms-2 text-primary" />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {paginatedData?.length && !isloading ? (
              paginatedData.map((vals, index) => (
                <tr key={index} className={rowHover ? "table-row-hover" : ""}>
                  {cols.map((col, colIndex) => (
                    <td
                      key={col?.id || colIndex}
                      style={col?.bodyStyle}
                      onClick={col?.click}
                      className={col?.bodyClass || "text-start items-center py-2 px-3 "}
                    >
                      {col?.iskey
                        ? col.render(
                            vals[col.key],
                            (currentPage - 1) * numberOfData + index,
                            { currentPage, itemsPerPage: numberOfData }
                          )
                        : col.render(
                            vals,
                            (currentPage - 1) * numberOfData + index,
                            { currentPage, itemsPerPage: numberOfData }
                          )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={cols.length}
                  className="text-center py-4 text-uppercase"
                >
                  {!isloading ? (
                    "No Data Found."
                  ) : (
                    <Spinner animation="border" />
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {/* Pagination */}
      {isPaginate && numberOfData < data.length && (
        <div className="d-flex justify-content-center mt-3 mb-2">
          <Button variant="primary" onClick={PaginationOnButtonClick}>
            Show More
          </Button>
        </div>
      )}
    </div>
  );
};

DynamicTable.propTypes = {
  cols: PropTypes.array.isRequired,
  response: PropTypes.any.isRequired,
  isPaginate: PropTypes.bool,
  headerClass: PropTypes.string,
  rowHover: PropTypes.bool,
  numberOfData: PropTypes.number,
  isBgTransparent: PropTypes.bool,
  PaginationOnButtonClick: PropTypes.func,
  fixedHeight: PropTypes.bool,
  hideHeader: PropTypes.bool,
  isloading: PropTypes.bool,
  currentPage: PropTypes.number,
  // offset: PropTypes.number,
};

export default memo(DynamicTable);
